export const FAQ_ITEMS = [
  {
    q: "Preciso saber programar ou ter equipe técnica?",
    a: "Não. A instalação do Claude Code a gente faz junto, no seu computador, e você usa conversando, em português. O programa é desenhado para empresários e gestores.",
  },
  {
    q: "O programa é individual ou em grupo?",
    a: "Individual por padrão: as 4 sessões são só sobre a sua empresa. Se quiser levar a sua equipe, existe o formato de grupo fechado, com escopo e valor combinados antes.",
  },
  {
    q: "Como funcionam as 4 sessões?",
    a: "São 4 encontros ao vivo de 1h30, online. Sessão 01: o mapa da sua operação. Sessão 02: a instalação do Claude Code no seu computador. Sessão 03: os agentes e as skills que a sua operação pede. Sessão 04: o seu time de IA rodando.",
  },
  {
    q: "Quando acontecem? Tem data fixa?",
    a: "Não. A agenda é montada com você na conversa de 20 minutos após o pagamento.",
  },
  {
    q: "O que eu levo de fato no final?",
    a: "O mapa da sua operação, o Claude Code instalado e configurado no seu computador, a memória da empresa numa arquitetura que é sua, agentes e skills criados para a sua necessidade e um processo da sua empresa rodando sem você no meio.",
  },
  {
    q: "E se amanhã surgir uma IA melhor que o Claude?",
    a: "Você troca e não perde nada. Tudo fica em pastas no seu computador, numa arquitetura pronta para Claude, ChatGPT, Gemini ou Grok.",
  },
  {
    q: "Quanto vou gastar de ferramenta?",
    a: "O plano do Claude. O básico sai por volta de R$ 110 por mês e basta para começar.",
  },
  {
    q: "Meus dados ficam onde?",
    a: "No seu computador e no seu GitHub. Não ficam presos em plataforma nenhuma.",
  },
  {
    q: "Qual é o investimento?",
    a: "Individual: 12× de R$ 596,33 no cartão ou R$ 6.870 à vista no Pix (chave znith@campioto.com). Grupo fechado: valor sob consulta, conforme o número de pessoas e o escopo.",
  },
  {
    q: "Como funciona o pagamento e a conversa de 20 minutos?",
    a: "Você preenche o formulário e recebe o link seguro de pagamento (ou paga no Pix). Confirmado o pagamento, você agenda a conversa de 20 minutos com a Leilaine, onde definimos a agenda das 4 sessões e a área que vai para o mapa.",
  },
  {
    q: "Serve para quem ainda não usa IA?",
    a: "Sim. Começamos pelo mapa da sua operação. O que muda é o destino: em vez de aprender sobre IA, você termina com IA operando dentro da sua empresa.",
  },
  {
    q: "E depois das 4 sessões?",
    a: "Você segue na comunidade, com apoio por WhatsApp, e tem 30% de desconto nos eventos presenciais e 80% nos online da ZNITH.AI.",
  },
];
